import { render, staticRenderFns } from "./SettingsBotEditor.vue?vue&type=template&id=5e8c189c&"
import script from "./SettingsBotEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsBotEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports